import React from 'react';
import { Card, Button, Table, Badge, Input, Spinner, FormGroup, Label } from 'reactstrap';
import { Search, Plus, Download, Upload, FileText, Edit, Trash2 } from 'lucide-react';
import './TablePanelArrastre.css';

// Función helper para obtener valores anidados
const getNestedValue = (obj, path) => {
  const value = path.split('.').reduce((current, key) => {
    return current?.[key];
  }, obj);
  
  // Si el valor es un objeto, intentar obtener la propiedad 'nombre' o convertir a string
  if (value && typeof value === 'object') {
    if (value.nombre) return value.nombre;
    if (value.toString && typeof value.toString === 'function') {
      return value.toString();
    }
    return JSON.stringify(value);
  }
  
  // Si es null o undefined, retornar string vacío
  if (value === null || value === undefined) {
    return '';
  }
  
  return value;
};

const TablePanelArrastre = ({ 
  catalogo, 
  elementos = [], 
  columnas = [], 
  onEdit, 
  onDelete, 
  onAdd, 
  onSearch,
  onStatusChange,
  loading = false,
  ModalComponent,
  ModalComponentEdit
}) => {
  
  const formatCatalogoName = (name) => {
    return name.split(/(?=[A-Z])/).join(' ').toLowerCase()
      .replace(/^\w/, c => c.toUpperCase());
  };

  return (
    <div className="catalogo-container">
      {/* Header */}
      <Card className="catalogo-header">
        <div className="header-content">
          <div className="title-section">
            <h2 className="catalogo-title">
              {formatCatalogoName(catalogo)}
            </h2>
            <Badge color="info" className="elementos-count">
              {elementos.length} elementos
            </Badge>
          </div>
          
          <div className="actions-section" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div className="search-container">
              <Search size={18} className="search-icon" />
              <Input
                type="text"
                placeholder="Buscar en la tabla..."
                className="search-input"
                onChange={(e) => onSearch?.(e.target.value)}
              />
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {ModalComponent || (
                <Button color="success" size="sm" onClick={onAdd}>
                  <Plus size={16} />
                  Nuevo
                </Button>
              )}
            </div>
          </div>
        </div>
      </Card>

      {/* Content */}
      <Card className="catalogo-content">
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Cargando datos...</p>
          </div>
        ) : elementos.length === 0 ? (
          <div className="empty-state">
            <FileText size={64} className="empty-icon" />
            <h4>No hay elementos disponibles</h4>
            <p>Comienza agregando un nuevo elemento al catálogo</p>
            
            
          </div>
        ) : (
          <div className="table-container">
            <Table responsive hover className="modern-table">
              <thead>
                <tr>
                  {columnas.filter(col => col.columna !== 'idUsuario' && col.columna !== 'idLocalidad' && col.columna !== 'idTransportista').map((col, index) => (
                    <th key={index} className={col.columna === 'editar' ? "table-header actions-header" : "table-header"}>
                      {col.columna === 'editar' ? 'Acciones' : col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {elementos.map((elemento, index) => {
                  const editarCol = columnas.find(col => col.columna === 'editar');
                  return (
                    <tr key={elemento.id || index} className="table-row">
                      {columnas.filter(col => col.columna !== 'idUsuario' && col.columna !== 'idLocalidad' && col.columna !== 'idTransportista').map((col, colIndex) => {
                        if (col.columna === 'editar') {
                          return (
                            <td key={colIndex} className="table-cell actions-cell">
                              <div className="action-buttons-row">
                               {ModalComponentEdit ? 
                                  React.cloneElement(ModalComponentEdit, { 
                                    datosForm: {
                                      ...ModalComponentEdit.props.datosForm,
                                      elementos: elemento,
                                      accion: "modificar"
                                    }
                                  }) : (
                                  <Button color="success" size="sm" onClick={ ()=> onEdit?.(elemento)}>
                                      <Edit size={16} />
                                    Editar
                                  </Button>
                                )}
                                <Button 
                                  color="danger" 
                                  size="sm" 
                                  outline
                                  onClick={() => onDelete?.(elemento)}
                                  title="Eliminar"
                                >
                                  <Trash2 size={14} />
                                </Button>
                              </div>
                            </td>
                          );
                        } else if (col.columna === 'estatus') {
                          return (
                            <td key={colIndex} className="table-cell">
                              <div className="status-switch">
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={elemento.estatus === 1 || elemento.estatus === true}
                                    onChange={() => onStatusChange?.(elemento.id, elemento.estatus ? 0 : 1, elemento.idLocalidad, elemento.idTransportista)}
                                  />
                                  <span className="slider"></span>
                                </label>
                                <span className={`status-text ${(elemento.estatus === 1 || elemento.estatus === true) ? 'active' : 'inactive'}`}>
                                  {(elemento.estatus === 1 || elemento.estatus === true) ? 'Activo' : 'Inactivo'}
                                </span>
                              </div>
                            </td>
                          );
                        } else {
                          return (
                            <td key={colIndex} className="table-cell">
                              {col.form ? col.form(elemento) : 
                               getNestedValue(elemento, col.columna)}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
};

export default TablePanelArrastre;